import { type ElementType, type ReactNode } from 'react';
import { cn } from '@/lib/cn.js';

interface EmptyStateProps {
  icon: ElementType;
  title: string;
  desc?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, desc, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-16 text-center', className)}>
      <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-border bg-secondary/60 text-muted-foreground">
        <Icon size={22} />
      </div>
      <div className="space-y-1">
        <h3 className="font-semibold">{title}</h3>
        {desc && <p className="mx-auto max-w-sm text-sm text-muted-foreground">{desc}</p>}
      </div>
      {action}
    </div>
  );
}
